import { PurchasePartialStoreState, PURCHASE_STATE_KEY } from './purchase.reducer';

export const getPurchaseState = (state: PurchasePartialStoreState) => state[PURCHASE_STATE_KEY];

export const getPurchaseSteps = (state: PurchasePartialStoreState) => state[PURCHASE_STATE_KEY].steps;

export const getActivePurchaseStep = (state: PurchasePartialStoreState) => state[PURCHASE_STATE_KEY].activeStep;

export const getPayloads = (state: PurchasePartialStoreState) => state[PURCHASE_STATE_KEY].payloads;

export const getFlowCompleted = (state: PurchasePartialStoreState) => state[PURCHASE_STATE_KEY].flowCompleted;

export const getInvoiceLoading = (state: PurchasePartialStoreState) => state[PURCHASE_STATE_KEY].invoiceLoading;

export const getNotificationsFormValidity = (state: PurchasePartialStoreState) =>
    state[PURCHASE_STATE_KEY].notificationFormValidity;

export const getCategoryProductDetails = (state: PurchasePartialStoreState) =>
    state[PURCHASE_STATE_KEY].categoryProductDetails;
